/**
 * THIS IS AN AUTO-GENERATED FILE. DO NOT EDIT DIRECTLY.
 * To edit the values of the shared constants, see graphql/src/constant-exports.js
 */

export const DEFAULT_KEYBOARD_SHORTCUTS = [
  { id: 'LAYOUT_1x1', key: '1' },
  { id: 'LAYOUT_1x2', key: '2' },
  { id: 'LAYOUT_1x3', key: '3' },
  { id: 'LAYOUT_1x4', key: null },
  { id: 'LAYOUT_2x1', key: null },
  { id: 'LAYOUT_2x2', key: '4' },
  { id: 'LAYOUT_2x3', key: '6' },
  { id: 'LAYOUT_2x4', key: '8' },
  { id: 'LAYOUT_3x1', key: null },
  { id: 'LAYOUT_3x2', key: null },
  { id: 'LAYOUT_4x1', key: null },
  { id: 'LAYOUT_3x3', key: null },
  { id: 'PAN', key: 'p' },
  { id: 'ZOOM', key: 'z' },
  { id: 'HORIZONTAL_FLIP', key: 'h' },
  { id: 'VERTICAL_FLIP', key: 'v' },
  { id: 'WWWC', key: 'w' },
  { id: 'LENGTH', key: 'l' },
  { id: 'ANGLE', key: 'a' },
  { id: 'ARROW', key: 'd' },
  { id: 'COBB_ANGLE', key: 'x' },
  { id: 'ELLIPSE', key: 'o' },
  { id: 'CIRCLE', key: 'f' },
  { id: 'INVERT', key: 'i' },
  { id: 'FREE_ROTATE', key: 'g' },
  { id: 'MAGNIFY_GLASS', key: 'm' },
  { id: 'RECTANGLE', key: 'r' },
  { id: 'ROTATE', key: 't' },
  { id: 'ROTATE_90', key: 'n' },
  { id: 'ERASER', key: 'e' },
  { id: 'VERTEBRAE_LABEL', key: 'q' },
  { id: 'LANDMARK', key: 'k' },
  { id: 'FAST_SCROLL', key: 's' },
  { id: 'REGULAR_SCROLL', key: 'y' },
  { id: 'CONTOUR', key: 'c' },
  { id: 'JUMP_TO', key: 'j' },
  { id: 'RESET', key: 'shift+r' },
  { id: 'ERASE_ALL', key: 'shift+e' },
  { id: 'MANUAL_LINKED_SCROLL', key: 'ctrl+m' },
  { id: 'AUTOMATIC_LINKED_SCROLL', key: 'shift+l' },
  { id: 'KEY_IMAGE', key: 'b' },
  { id: 'SWAP_CELLS', key: 'shift' },
  { id: 'NEXT_SET', key: 'right' },
  { id: 'PREV_SET', key: 'left' },
  { id: 'NEXT_SERIES', key: null },
  { id: 'PREV_SERIES', key: null },
  { id: 'SWITCH_VIEWTYPE', key: 'shift+t' },
  { id: 'CINE', key: 'shift+b' },
  { id: 'CLEAR_VIEWPORT', key: null },
  { id: 'HP_CREATE_NEW', key: null },
  { id: 'HP_EDIT', key: null },
  { id: 'HP_RESET', key: null },
  { id: 'HP_BROWSE', key: null },
  { id: 'HP_STEP_NEXT', key: null },
  { id: 'HP_STEP_PREVIOUS', key: null },
  { id: 'HP_STEP_FIRST', key: 'alt+home' },
  { id: 'HP_STEP_LAST', key: 'alt+end' },
  { id: 'HP_SAVE_STEP', key: null },
  { id: 'HP_RESET_STEP', key: null },
  { id: 'TOGGLE_THUMBNAIL_BAR', key: ']' },
  { id: 'TOGGLE_TOOL_BAR', key: '[' },
  { id: 'TOGGLE_CAD_ANNOTATION', key: 'shift+c' },
  { id: 'REPORTER_PREVIOUS', key: null },
  { id: 'REPORTER_NEXT', key: null },
  { id: 'REPORTER_TOGGLE_DICTATION', key: null },
  { id: 'REPORTER_SUBMIT_REPORT', key: null },
  { id: 'REPORTER_GENERATE_IMPRESSION', key: null },
  { id: 'REPORTER_DISCARD_REPORT', key: null },
  { id: 'REPORTER_DRAFT_REPORT', key: null },
  { id: 'REPORTER_COMMAND_MODE', key: null },
];
export const DEFAULT_VOI_LUT_SIZE = 65536;
